import { Module } from 'vuex';
import RootState from '../../state';
import {
    queryItemByPageUsingPOST,
    queryByPageUsingPOST,
    queryItemRateV2UsingPOST,
} from '@services/distribution/common-plan-controller';
import { getItemExclusiveUsingPOST, listExclusiveV2UsingPOST } from '@services/distribution/exclusive-plan-controller';
import { IQueryPlanByPageParam, IPlanVo, IExclusiveDistributorError } from '../../../../services/distribution/models';
export interface ISelectPlan extends IPlanVo {
    selected: boolean;
    checked: boolean;
}

interface IDistributionState {
    stepIdx: number;
    disSubmitParams: IQueryPlanByPageParam;
    disGoodsList: IPlanVo[]; // 分销商品列表
    disTotalCount: number; // 分销商品总数
    goodsList: IPlanVo[]; // 分销管理-新增商品列表
    selectedGoodsList: ISelectPlan[]; // 分销管理-选中商品列表
    checkedGoodsList: ISelectPlan[]; // 分销管理-选中商品列表批量设置列表
    groupCommissionRate: string; // 批量设置佣金比率
    goodsTotalCount: number; // 新建分销商品总数
    allowZeroRate: boolean; // 是否允许分销佣金比率设置为0
    currentMode: string; // 分销类型； "COMMON":通用分销   "EXCLUSIVE":专属分销
    spreaderShowList: IExclusiveDistributorError[]; // 推广者数据（专属分销使用）
    spreaderIdList: number[]; // 推广者ID（专属分销使用）
    exclusivePlanErrorList: IExclusiveDistributorError[]; // 不合法的推广者ID
    planRateList: any[];
    enableRemovePlan: boolean; // 通用分销是否能删除
}

const intialState = {
    stepIdx: 0,
    disSubmitParams: {} as IQueryPlanByPageParam,
    disGoodsList: [] as IPlanVo[],
    disTotalCount: 0,
    goodsList: [] as ISelectPlan[],
    selectedGoodsList: [] as ISelectPlan[],
    checkedGoodsList: [] as ISelectPlan[],
    groupCommissionRate: '',
    goodsTotalCount: 0,
    allowZeroRate: false,
    currentMode: 'COMMON',
    // privilegeState: 1,
    submitCode: 0,
    enableRemovePlan: false,

    // 专属分销
    specDisPlansList: [] as IPlanVo[],
    specDisTotalCount: 0,
    spreaderShowList: [] as IExclusiveDistributorError[],
    spreaderIdList: [] as number[],
    exclusivePlanErrorList: [] as IExclusiveDistributorError[],
    planRateList: [] as any[],
};

const carStore: Module<IDistributionState, RootState> = {
    namespaced: true,
    state: intialState,
    mutations: {
        setStepIdx(state: typeof intialState, payload: number) {
            state.stepIdx = payload;
        },
        setDisSubmitParams(state: typeof intialState, payload: IQueryPlanByPageParam) {
            state.disSubmitParams = payload;
        },
        setDisGoodsList(state: typeof intialState, planVoList) {
            state.disGoodsList = planVoList;
        },
        // setPrivilegeStatus(state: typeof intialState, privilegeState) {
        //     state.privilegeState = privilegeState;
        // },
        setSubmitCode(state: typeof intialState, submitCode) {
            state.submitCode = submitCode;
        },
        setDisTotalCount(state: typeof intialState, { page }) {
            state.disTotalCount = page.totalCount;
        },
        setGoodsList(state: typeof intialState, itemVoList) {
            const arr = itemVoList.slice(0);
            if (arr.length > 0) {
                arr.forEach(_ => {
                    _.selected = false;
                    _.checked = false;
                    _.rate = '';
                });
            }
            state.goodsList = arr;
        },
        setSpecialGoodsList(state: typeof intialState, itemVoList) {
            const arr = itemVoList.slice(0);
            if (arr.length > 0) {
                arr.forEach(_ => {
                    _.selected = false;
                    _.checked = false;
                    _.rate = '';
                    _.id = '';
                });
            }
            state.goodsList = arr;
        },
        setSelectedGoodsList(state: typeof intialState, payload: ISelectPlan[]) {
            state.selectedGoodsList = payload;
        },
        setCheckedGoodsList(state: typeof intialState, payload: ISelectPlan[]) {
            state.checkedGoodsList = payload;
        },
        setGroupCommissionRate(state: typeof intialState, payload: string) {
            state.groupCommissionRate = payload;
        },
        setGoodsTotalCount(state: typeof intialState, { page }) {
            state.goodsTotalCount = page.totalCount;
        },
        setAllowZeroRate(state: typeof intialState, allowZeroRate) {
            state.allowZeroRate = allowZeroRate;
        },
        setCurrentMode(state: typeof intialState, payload: string) {
            state.currentMode = payload;
        },
        setMuatations(state: typeof intialState, payload: any) {
            if (typeof payload !== 'object' || payload === null) {
                return;
            }
            if (Array.isArray(payload)) {
                payload.forEach(item => {
                    const { key, val } = item;
                    state[key] = val;
                });
            } else {
                const { key, val } = payload;
                state[key] = val;
            }
        },
        setPlanRateList(state: typeof intialState, payload: any[]) {
            state.planRateList = payload;
        },
        setEnableRemovePlan(state: typeof intialState, payload: boolean) {
            state.enableRemovePlan = payload;
        }
    },
    actions: {
        // 分销管理-分销商品列表
        async getDisGoodsList({ commit, dispatch, state, rootState }, payload) {
            const { data } = await queryByPageUsingPOST({
                queryPlanByPageParam: {
                    ...payload,
                },
            });
            if (data) {
                const { planVoList, page, enableRemovePlan } = data;
                commit('setDisGoodsList', planVoList);
                commit('setDisTotalCount', { page });
                commit('setEnableRemovePlan', enableRemovePlan);
                // commit('setPrivilegeStatus', privilegeState);
            } else {
                commit('setDisGoodsList', []);
            }
        },
        // 分销管理-专属分销列表
        async getSpecDisPlansList({ commit, dispatch, state, rootState }, payload) {
            const { data } = await listExclusiveV2UsingPOST({
                param: { ...payload },
            });
            if (data) {
                const { planVoList, page } = data;
                const payload = [
                    { key: 'specDisPlansList', val: planVoList },
                    { key: 'specDisTotalCount', val: page.totalCount },
                ];
                commit('setMuatations', payload);
                // commit('setPrivilegeStatus', privilegeState);
            } else {
                const payload = [
                    { key: 'specDisPlansList', val: [] },
                    { key: 'specDisTotalCount', val: 0 },
                ];
                commit('setMuatations', payload);
            }
        },
        // 分销管理-商品列表
        async getGoodsList({ commit, dispatch, state, rootState }, payload) {
            const { data } = await queryItemByPageUsingPOST({
                queryItemByPagParam: {
                    ...payload,
                },
            });
            if (data) {
                const { itemVoList, page, allowZeroRate } = data;
                commit('setGoodsList', itemVoList);
                commit('setAllowZeroRate', allowZeroRate);
                // 搜索时不重置商品总数
                if (!('itemId' in payload)) {
                    commit('setGoodsTotalCount', { page });
                }
            } else {
                commit('setGoodsList', []);
            }
        },
        // 专属分销管理-商品列表
        async getSpecialGoodsList({ commit, dispatch, state, rootState }, payload) {
            const { data } = await getItemExclusiveUsingPOST({
                queryItemByPagParam: {
                    ...payload,
                },
            });
            if (data) {
                const { itemVoList, page, allowZeroRate } = data;
                commit('setGoodsList', itemVoList);
                commit('setAllowZeroRate', allowZeroRate);
                // 搜索时不重置商品总数
                if (!('itemId' in payload)) {
                    commit('setGoodsTotalCount', { page });
                }
            } else {
                commit('setSpecialGoodsList', []);
            }
        },
        // 查询选中商品佣金比率
        async getSelectedGoodsPlanRate({ commit, dispatch, state, rootState }, payload) {
            const itemIds = [] as number[];
            state.selectedGoodsList.forEach(_ => {
                itemIds.push(+_.itemId);
            });
            const { data } = await queryItemRateV2UsingPOST({
                queryItemRate: {
                    itemIds,
                },
            });
            const { allowZeroRate, itemRateVos } = data;
            commit('setPlanRateList', itemRateVos);
            commit('setAllowZeroRate', allowZeroRate);
        },
        // 查找某个商品的佣金比率
        async getGoodsPlanRate({ commit, dispatch, state, rootState }, payload) {
            const { data, status } = await queryItemRateV2UsingPOST({
                queryItemRate: {
                    itemIds: [payload],
                },
            });
            const { allowZeroRate, itemRateVos } = data;
            commit('setPlanRateList', itemRateVos);
            commit('setAllowZeroRate', allowZeroRate);
            status !== 200 && commit('setSubmitCode', status);
        },
    },
    getters: {},
};

export default carStore;
